"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Pagination = (props) => {
    let pages = -1;
    let currentPage = props.params.pageNumber;
    pages = Math.ceil(props.data.data.totalItems / props.params.pageSize);
    let pageChoices = [];
    let minPage = currentPage < 5 ? 0 : Math.max(0, currentPage - 4);
    for (let i = minPage; i <= currentPage; i++)
        pageChoices.push(i);
    if (currentPage < pages - 1) {
        let maxPage = Math.min(pages, currentPage + 10 - pageChoices.length);
        for (let i = currentPage + 1; i < maxPage; i++)
            pageChoices.push(i);
        if (maxPage < pages - 1)
            pageChoices.push(-1, pages - 1);
    }
    if (pageChoices[0] > 1)
        pageChoices.unshift(0, -1);
    else if (pageChoices[0] > 0)
        pageChoices.unshift(0);
    return ((0, jsx_runtime_1.jsx)("div", { className: "o-aircraft-register-pagination row col-12 col-lg-10 offset-lg-1 mb-5", children: (0, jsx_runtime_1.jsxs)("div", { className: "page-selection", children: [(0, jsx_runtime_1.jsx)("span", { className: "page-label", children: "Side" }), pageChoices.map((id, i) => {
                    return pageChoices[i] < 0 ? ((0, jsx_runtime_1.jsx)("span", { className: "spacer", children: "..." }, i)) : pageChoices[i] === currentPage ? ((0, jsx_runtime_1.jsx)("span", { className: "selected-page", children: pageChoices[i] + 1 }, i)) : ((0, jsx_runtime_1.jsx)("a", { href: "#", onClick: (ev) => {
                            ev.preventDefault();
                            props.changePagination(pageChoices[i]);
                        }, children: pageChoices[i] + 1 }, i));
                })] }) }));
};
exports.default = Pagination;
